function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getBusinessList, getBusinessData, getBusinessNData } from '@/api/statistic';
import echartsFrom from '@/components/echarts/index';
import countTo from 'vue-count-to';
export default {
  components: {
    echartsFrom: echartsFrom,
    countTo: countTo
  },
  data: function data() {
    return _defineProperty(_defineProperty(_defineProperty({
      text: [{
        name: '昨天',
        dateLimit: 'yesterday'
      }, {
        name: '最近7天',
        dateLimit: 'lately7'
      }, {
        name: '最近30天',
        dateLimit: 'lately30'
      }],
      timeVal: [],
      xAxis: [],
      yAxis: {
        type: 'value'
      },
      series: [{
        data: [],
        type: 'line'
      }],
      selectedList: [],
      selecterVales: null,
      dateLimit: 'yesterday'
    }, "timeVal", []), "dataTitlelist", [{
      name: '总单量',
      value: ''
    }, {
      name: '总金额',
      value: ''
    }, {
      name: '消耗福豆总额',
      value: ''
    }, {
      name: '客单价',
      value: ''
    }, {
      name: '售后单量',
      value: ''
    }, {
      name: '售后总金额',
      value: ''
    }]), "dataRight", [{
      name: '营业额',
      value: ''
    }, {
      name: '福豆支付金额',
      value: ''
    }, {
      name: '现金支付金额',
      value: ''
    }, {
      name: '售后退款金额',
      value: ''
    }, {
      name: '成交订单量',
      value: ''
    }, {
      name: '均单价',
      value: ''
    }]);
  },
  mounted: function mounted() {
    this.handleApi();
  },
  methods: {
    handleApi: function () {
      var _handleApi = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getBusinessList();
            case 1:
              res = _context.v;
              this.selectedList = res.list;
              this.selectedList.unshift({
                customerName: '全部',
                customerId: null
              });
              console.log(this.selectedList, '1151');
              this.selecterVales = this.selectedList[0].customerId;
              this.handleTitleList(this.selecterVales);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleApi() {
        return _handleApi.apply(this, arguments);
      }
      return handleApi;
    }(),
    handleTitleList: function () {
      var _handleTitleList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(customerId) {
        var res, titleDataMap;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getBusinessData({
                customerId: customerId
              });
            case 1:
              res = _context2.v;
              titleDataMap = {
                '总单量': res.totalOrderNum,
                '总金额': res.totalOrderAmount,
                '消耗福豆总额': res.totalFudouAmount,
                '客单价': res.averageOrderAmount,
                '售后单量': res.afterSaleOrderNum,
                '售后总金额': res.afterSaleOrderAmount
              };
              this.dataTitlelist.forEach(function (item) {
                item.value = titleDataMap[item.name] || 0;
              });
              this.handleSeach();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleTitleList(_x) {
        return _handleTitleList.apply(this, arguments);
      }
      return handleTitleList;
    }(),
    handleSeklectEd: function handleSeklectEd(value) {
      this.selecterVales = value;
      this.handleTitleList(this.selecterVales);
    },
    handleSeach: function () {
      var _handleSeach = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, echartOrderList, rightDataMap;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getBusinessNData({
                customerId: this.selecterVales,
                dateLimit: this.dateLimit
              });
            case 1:
              res = _context3.v;
              echartOrderList = res.echartOrderList ? res.echartOrderList : [];
              this.xAxis = echartOrderList.map(function (_ref2) {
                var date = _ref2.date;
                return date;
              });
              this.series[0].data = echartOrderList.map(function (_ref3) {
                var totalPrice = _ref3.totalPrice;
                return totalPrice;
              });
              rightDataMap = {
                '营业额': res.orderAmount,
                '福豆支付金额': res.fudouAmount,
                '现金支付金额': res.wxPayAmount,
                '售后退款金额': res.afterSaleOrderAmount,
                '成交订单量': res.orderNum,
                '均单价': res.averageOrderAmount
              };
              console.log(rightDataMap, 'rightDataMap');
              this.dataRight.forEach(function (item) {
                item.value = rightDataMap[item.name] || 0;
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleSeach() {
        return _handleSeach.apply(this, arguments);
      }
      return handleSeach;
    }(),
    onchangeTime: function () {
      var _onchangeTime = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.dateLimit = null;
              this.dateLimit = this.timeVal.join(',');
              this.handleSeach();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onchangeTime() {
        return _onchangeTime.apply(this, arguments);
      }
      return onchangeTime;
    }()
  }
};